import CircularProgress from "@vapor/react-material/CircularProgress";
import Stack from "@vapor/react-material/Stack";
import Typography from "@vapor/react-extended/ExtendedTypography";

const LoadingContent = () => {
    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
                backgroundColor: "hsl(199, 15%, 95%)",
                minHeight: "calc(100vh - 48px)",
            }}
        >
            <CircularProgress size={64} />
            <Typography
                variant="titleMedium"
                sx={{ marginTop: "2rem", marginBottom: "0.5rem" }}
            >
                Caricamento della pagina in corso…
            </Typography>
            <Typography variant="body">
                Rimani in attesa per visualizzare i dati disponibili sulla tua homepage.
            </Typography>
        </Stack>
    );
};

export default LoadingContent;
